jQuery(document).ready(function($) {
  $('.brand-search__chars.owl-carousel').each((index,item) => {
        const items = parseInt(($(item).width())/ 48);
		$(item).owlCarousel({
            items: items,
			loop:false,
			margin:8,
			nav:true,
			dots: false
		})
	})
   // $('*:contains(' + searchText + ')');
  $(".brand-search__search input").on('input', debounce(() => {
      const searchText = $(".brand-search__search input").val();
      if(searchText){
        const res = $(".brand__list a:contains('" + searchText + "')");
        $(".brand-search__results").empty()
        if(res.length > 0){
          res.each((index,item) => {
            $(".brand-search__results").append($(item).parent().html())
          })
        }else{
          
        }
        $(".brand-search__results").addClass("show")
      }else{
        $(".brand-search__results").removeClass("show")
      }
  },300));

  $(".brand-search__search input").blur(() =>{
    $(".brand-search__search input").val("")
    setTimeout(function () {
      $(".brand-search__results").removeClass("show")
    },500)
  })

  function debounce(fn, delay) {
      var timer = null;
      return function () {
          var context = this, args = arguments;
          clearTimeout(timer);
          timer = setTimeout(function () {
              fn.apply(context, args);
          }, delay);
      };
  }



  
  let sticky_bar_height = 80;
  let linkClicked = false;
  const nav = document.querySelector(".brand-search");
  
  let navTop = nav.getBoundingClientRect().top ;
  navTop = 537
  let scrollOffset = 75;

  
  const links = document.querySelectorAll('.brand-search__chars .char-item');

  updateOnClickStickyNavState(links);
  
  window.onscroll = function () {
    if($("body").width() < 990){
      scrollOffset = 190
    }
    const scrollPos_start = window.scrollY + parseInt(scrollOffset);
    if(scrollPos_start > navTop){
      nav.classList.add("fixed")
    }else{
      nav.classList.remove("fixed")
    };

    if (!linkClicked) {
      updateStickyNavState(links, scrollPos_start);
    }
  };

  function updateOnClickStickyNavState(links) {
    links.forEach(function (e) {
      var char = e.dataset.char;

      var refElement = document.querySelector(".brand_page [data-char='"+char+"']");
      if (refElement) {
        e.onclick = function (evt) {
          // Prevent default anchor click behavior
          evt.preventDefault();
          linkClicked = true;

          if(!$(nav).hasClass("fixed")){
            sticky_bar_height = 160
            if($("body").width() < 990){
              sticky_bar_height = 260
            }
          }else{
            sticky_bar_height = 80
            if($("body").width() < 990){
              sticky_bar_height = 100
            }
          }
          
          var section_top = refElement.getBoundingClientRect().top + window.scrollY - sticky_bar_height - scrollOffset;
          // Added a delay to fix scroll bug on first reload page
          setTimeout(function () {
            window.scroll({
              top: section_top,
              behavior: 'smooth',
            });
          }, 100);

          // Reset linkClicked flag after a delay (e.g., 1000ms)
          setTimeout(function () {
            linkClicked = false;
          }, 100);
        };
      }
    });
  }

  function updateStickyNavState(links, scrollPos_start) {
    let lastIndex = 0;
    links.forEach( (e,index)=> {
      var char = e.dataset.char;
      var refElement = document.querySelector(".brand_page [data-char='"+char+"']");
      if (refElement) {
        const section_top = refElement.getBoundingClientRect().top + window.scrollY - sticky_bar_height  - 10;
        if (scrollPos_start >= section_top) {
          links.forEach(function (link) {
            if (link !== e) {
              link.classList.remove('active');
            }
          });

          e.classList.add('active');
          lastIndex = index;
        }
      }
    });
    $(".brand-search__chars.owl-carousel").trigger('to.owl.carousel', [lastIndex]);
    
  }
});